module.exports = {
  "zones": {
    "Asia/Rangoon": ["z", {
      "wallclock": -778377600000,
      "format": "+0630",
      "abbrev": "+0630",
      "offset": 23400000,
      "posix": -778410000000,
      "save": 0
    }, {
      "wallclock": -873244800000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -873268200000,
      "save": 0
    }, {
      "wallclock": -1577923200000,
      "format": "+0630",
      "abbrev": "+0630",
      "offset": 23400000,
      "posix": -1577946287000,
      "save": 0
    }, {
      "wallclock": -2840140800000,
      "format": "RMT",
      "abbrev": "RMT",
      "offset": 23087000,
      "posix": -2840163887000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 23087000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};